import { FC } from 'react';

import usePlankTableStore from '../../hooks/usePlankTableStore';

import styles from './Indelen.module.css';

type IndelenNavigatieProps = {
  afterNavigation?: (tabView: 'materieel' | 'knoop') => void;
};
const IndelenNavigatie: FC<IndelenNavigatieProps> = ({ afterNavigation }) => {
  const isRegionaal = usePlankTableStore((state) => state.tableView === 'knoop');
  const setTableView = usePlankTableStore((state) => state.setTableView);
  return (
    <div
      style={{
        display: 'inline-flex',
        width: '269px',
        gap: '4px',
        borderRadius: '5px',
        background: 'var(--tractie-color-background-input)',
        border: 'solid 1px var(--tractie-color-border-input-default)',
        padding: '4px',
        alignItems: 'center',
      }}
    >
      <div>
        <button
          className={[styles.indelenNavLink, isRegionaal ? '' : styles.selectedNavLink].join(' ')}
          onClick={() => {
            setTableView('materieel');
            if (afterNavigation) afterNavigation('materieel');
          }}
        >
          Per materieeltype
        </button>
      </div>
      <div style={{ borderLeft: 'solid 1px var(--tractie-color-border-default)', height: '16px' }} />
      <div>
        <button
          className={[styles.indelenNavLink, isRegionaal ? styles.selectedNavLink : ''].join(' ')}
          onClick={() => {
            setTableView('knoop');
            if (afterNavigation) afterNavigation('knoop');
          }}
        >
          Per locatie
        </button>
      </div>
    </div>
  );
};
export default IndelenNavigatie;
